import FJPhotoRemoveBgBg from '../view/FJPhotoRemoveBgBg';
import { useSelector, useDispatch } from 'react-redux';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useState, useCallback, useMemo, memo } from 'react';

import FJLocalStore from '../../../../store/FJLocalStore';
import { useEffect } from 'react';
import FJActionAiHistoryCommon from '../../../../redux/action/FJActionAiHistoryCommon';
import FJActionColorCommon from '../../../../redux/action/FJActionColorCommon';
import FJHeaderConfig from '../../../../config/FJHeaderConfig';
import useLocalStore from '../../../../hooks/useLocalStore';

const MENU_TAB_LIST = [
    {
        text: FJLocalStore._('photo'),
    },
    {
        text: FJLocalStore._('color'),
    },
    {
        text: FJLocalStore._('ai-photo'),
    },
];

const FJPhotoRemoveBgBgContainer = memo(function FJPhotoRemoveBgBgContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const [curMenuIndex, setCurMenuIndex] = useState(0);
    const curLanguage = FJLocalStore.currentTag();

    const bgApplyToAll = useSelector(state => state.photoBgRemover.bgApplyToAll);

    const flexClipBgLoadStatus = useSelector(state => state.photoBgRemover.flexClipBgLoadStatus);
    const backgroundPhotoList = useSelector(state => state.photoBgRemover.backgroundPhotoList);
    const aiTextToImageHistoryList = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryList);
    const aiTextToImageHistoryLoadStatus = useSelector(state => state.aiHistoryCommon.aiTextToImageHistoryLoadStatus);
    const selectColorList = useSelector(state => state.colorCommon.selectColorList);
    const defaultColorList = useSelector(state => state.colorCommon.defaultColorList);
    const curSelectBgData = useSelector(state => state.photoBgRemover.curSelectBgData);
    const curBgColor = useSelector(state => state.photoBgRemover.curBgColor);
    const isCustomRemoveBg = useSelector(state => state.photoBgRemover.curMenuIndex === 1);
    const customUploadBgFileList = useSelector(state => state.photoBgRemover.customUploadBgFileList);
    const bgUsePhotoLoadingList = useSelector(state => state.photoBgRemover.bgUsePhotoLoadingList);
    const autoBgImageDataList = useSelector(state => state.photoBgRemover.autoBgImageDataList);

    const isApply = useSelector(state => state.common.isApplyButton);

    const isShowApplyToAll = useMemo(() => {
        return !isCustomRemoveBg && autoBgImageDataList && autoBgImageDataList.length > 1;
    }, [isCustomRemoveBg, autoBgImageDataList]);

    const colorList = useMemo(() => {
        return [...selectColorList, ...defaultColorList];
    }, [selectColorList, defaultColorList]);

    useEffect(() => {
        if (curMenuIndex === 2) {
            dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList());
        }
    }, [curMenuIndex, dispatch]);

    const handleApplyToAll = useCallback(
        value => {
            dispatch(FJActionPhotoBgRemover.bgApplyToAllAction(value));
        },
        [dispatch],
    );

    const showBgListModel = useCallback(() => {
        dispatch(FJActionPhotoBgRemover.initFlexClipBackgroundData());
    }, [dispatch]);

    const hideBgListModel = useCallback(() => {}, []);

    const handleColorChange = useCallback(
        (color, changeType) => {
            dispatch(FJActionPhotoBgRemover.setBackgroundColorAction(color, changeType));
        },
        [dispatch],
    );

    const addSelectColor = useCallback(() => {
        if (curBgColor === '') return;
        dispatch(FJActionColorCommon.addSelectColorListAction(curBgColor));
    }, [dispatch, curBgColor]);

    const handleBgItemClick = useCallback(
        (item, isAiPhoto = false) => {
            dispatch(FJActionPhotoBgRemover.setBackgroundImageAction(item, isAiPhoto));
        },
        [dispatch],
    );

    const uploadBg = useCallback(
        file => {
            dispatch(FJActionPhotoBgRemover.uploadBgAction(file));
        },
        [dispatch],
    );

    const removeClick = useCallback(() => {
        dispatch(FJActionPhotoBgRemover.removeBgAction());
    }, [dispatch]);

    const handleGenerateNow = useCallback(() => {
        window.open(`${curLanguage === 'en' ? '' : '/' + curLanguage}${FJHeaderConfig.aiMenuList[3].href}`);
    }, [curLanguage]);

    const onClickRetry = useCallback(() => {
        dispatch(FJActionPhotoBgRemover.initFlexClipBackgroundData());
    }, [dispatch]);

    const onClickAiRetry = useCallback(() => {
        dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList());
    }, [dispatch]);

    return (
        <FJPhotoRemoveBgBg
            flexClipBgLoadStatus={flexClipBgLoadStatus}
            backgroundPhotoList={backgroundPhotoList}
            customUploadBgFileList={customUploadBgFileList}
            bgApplyToAll={bgApplyToAll}
            menuTabList={MENU_TAB_LIST}
            curMenuIndex={curMenuIndex}
            isShowApplyToAll={isShowApplyToAll}
            aiTextToImageHistoryList={aiTextToImageHistoryList}
            aiTextToImageHistoryLoadStatus={aiTextToImageHistoryLoadStatus}
            colorList={colorList}
            activeColor={curBgColor}
            curSelectBgData={curSelectBgData}
            bgUsePhotoLoadingList={bgUsePhotoLoadingList}
            handleColorChange={handleColorChange}
            handleApplyToAll={handleApplyToAll}
            hideBgListModel={hideBgListModel}
            showBgListModel={showBgListModel}
            setCurMenuIndex={setCurMenuIndex}
            addSelectColor={addSelectColor}
            handleBgItemClick={handleBgItemClick}
            uploadBg={uploadBg}
            handleGenerateNow={handleGenerateNow}
            removeClick={removeClick}
            onClickRetry={onClickRetry}
            onClickAiRetry={onClickAiRetry}
        />
    );
});

export default FJPhotoRemoveBgBgContainer;
